import { ClickType, ElementType, Click, Impression } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { bianka } from '@fiverr-private/obs';

export interface ReportClickProps {
    eventName: string;
    pageName: string;
    componentName: string;
    componentType?: ElementType;
    componentText?: string;
}

export const reportClickBase = ({
    eventName,
    pageName,
    componentName,
    componentType = ElementType.BUTTON,
    componentText,
}: ReportClickProps): void => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: eventName,
            page: { name: pageName, ctxId: pageCtxId },
            clickType: ClickType.UNSPECIFIED,
            element: {
                name: componentName,
                type: componentType,
                numberOfElements: 1,
                ...(componentText ? { text: { value: componentText } } : {}),
            },
        },
    });
};

export interface ReportImpressionProps {
    eventName: string;
    pageName: string;
    componentName: string;
    componentType?: string;
    componentText?: string;
}

export const reportImpressionBase = ({
    eventName,
    pageName,
    componentName,
    componentType,
    componentText,
}: ReportImpressionProps): void => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: eventName,
            page: { name: pageName, ctxId: pageCtxId },
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: componentName,
                ...(componentType ? { type: componentType } : {}),
                ...(componentText ? { text: componentText } : {}),
            },
        },
    });
};
